import React from 'react';

export const DashboardHeader: React.FC = () => {
  return (
    <header className="mb-10">
      <h1 className="text-4xl font-extrabold text-gray-900">Αρχική Σελίδα</h1>
      <p className="text-gray-600 mt-2">Καλώς ορίσατε στο σύστημα Heraclides.Ortho.</p>
    </header>
  );
};